export const addAuthHeaders = (headers) => {
    headers.append("x-csrf-token", Liferay.authToken);
    // For local development only
    if (typeof Liferay.authToken === 'undefined') {
        headers.append("Authorization", "Basic cG9ydGFsLmFkbWluQHVwMmQ1LmRlOnRlc3QxMjM=")
    }
}

export async function fetchProducts(ids, damageReportReferenceNumber, isSingleChoiceMode) {
    const headers = new Headers();
    addAuthHeaders(headers)

    const requestOptions = {
        method: "GET",
        headers: headers,
        redirect: "follow"
    };
    const comparisonTable = document.querySelector("up2date-comparison-table");


    let url = `/o/partshop/comparison?codes=${ids}&scopeGroupId=${Liferay.ThemeDisplay.getScopeGroupId()}&plid=${Liferay.ThemeDisplay.getPlid()}`;
    if(comparisonTable?.hasAttribute("custom-details-url")) {
        url += "&customDetailsUrl=" + comparisonTable?.getAttribute("custom-details-url");
    }
    if(isSingleChoiceMode) {
        url += "&singleSelectionAccountId=" + window.Liferay.CommerceContext.account.accountId;
    }
    url += "&accountId=" + window.Liferay.CommerceContext.account.accountId;
    if(damageReportReferenceNumber) {
        url += "&damageReportReferenceNumber=" + damageReportReferenceNumber;
    }
    const response = await Liferay.Util.fetch(url, requestOptions)
    if(response.status !== 200) {
        throw new Error("An unexpected error occurred.")
    }
    return await response.json();
}